import { htmlToText } from "html-to-text"

function startsWithNumber(str) {
    const regex = /^\s*(\d+)(\.\d+)*(\))?\s/
    const match = regex.exec(str)
    if (!match) {
        return null
    }

    const subNumbers = match[0].match(/\.\d+/g)
    return {
        number: match[1],
        subNumbers: subNumbers ? subNumbers.map((subNumber) => subNumber.slice(1)) : [],
    }
}

function normalizeActions(text) {
    let prev
    do {
        prev = text
        text = text.replace(/<!--[\s\S]*?-->/g, "")
    } while (text !== prev)
    return text.replace(/<br\s*\/?>(\s|&nbsp;)*/gi, "<br>").replace(/(<br>)+/gi, "<br>")
}

function getActions(text) {
    return text
}

const normalize = {
    htmlToText,
    startsWithNumber,
    normalizeActions,
    getActions,
}

export { htmlToText, startsWithNumber, normalizeActions, getActions }
export default normalize
